/*=========================================================================================
  File Name: moduleTheoryRatingManagement.js
  Description: Receipt Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Sib
  Author URL: http://www.organix-it.com
==========================================================================================*/

import state from './moduleManoeuvreRatingManagementState.js'
import mutations from './moduleManoeuvreRatingManagementMutations.js'
import actions from './moduleManoeuvreRatingManagementActions.js'
import getters from './moduleManoeuvreRatingManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}